export default {"src":"/_next/static/image/public/icons/localisation.92c8d6b4ccecc73e79f8579ea39ae37c.svg","height":20,"width":20};